
<div class="TopBar DarkNavigationBar">
  <div v-if="!isGuest" class="ButtonGroup">
    <a href="/">&larr; Back</a>
  </div>

  <div v-if="isDemo" class="ButtonGroup">
    <a class="MenuButton" href="/whiteboards/new_guest"
      >Make a whiteboard that saves</a
    >
  </div>

  <div class="ButtonGroup" v-if="!isDemo">
    <div class="BoardName" v-on:click="openBoardMetadataModal">
      <div>
        <span v-if="state.whiteboard.isTemplate">📘 </span>
        {{ state.whiteboard.name }}
      </div>
      <Countdown v-if="hasCountdown"></Countdown>
    </div>
  </div>

  <div class="ButtonGroup">
    <div class="BoardName">
      <a target="_blank" href="https://qapla.pro">Qapla Software Development</a>
    </div>
  </div>

  <div class="ButtonGroup">
    <a
      v-if="state.featureFlags.websocket_server && isGuest"
      v-on:click="editname"
    >
      {{ state.user.username }}
    </a>

    <TwoStateIconButton
      :value="isFullscreen"
      :onClick="toggleFullscreen"
      classExtra="DesktopOnly"
      iconFalse="expand-outline-white"
      iconTrue="contract-outline-white"
    >
    </TwoStateIconButton>

    <button class="MenuButton" v-on:click="openBoardMetadataModal">
      <img class="m-full-size" :src="'/img/icons/cog-outline-white.svg'" />
    </button>

    <LockButton
      v-if="isOwner"
      :value="state.isLocked"
      :onClick="toggleLocked"
    >
    </LockButton>

    <button class="MenuButton" v-on:click="downloadImage">
      Download image
    </button>

    <button
      v-on:click="openShareModal"
      v-if="state.featureFlags.share_prompt"
      class="MenuButton ShareButton"
    >
      Share
    </button>
  </div>
</div>
